import Confetti from 'react-confetti';

import { type ConfettiPatternProps } from 'hb-react/frontoffice/components/SuccessConfetti/types';

export const DefaultPattern = ({
  onConfettiComplete,
}: ConfettiPatternProps) => (
  <Confetti
    width={window.innerWidth}
    height={window.innerHeight}
    gravity={0.3}
    numberOfPieces={300}
    onConfettiComplete={onConfettiComplete}
    recycle={false}
  />
);
